
















































import Vue from 'vue';

import i18n from '@/locales/i18n';

interface ComponentData {
	copyState: boolean | null
}

export default Vue.extend( {
	props: {
		variant: {
			type: String,
			default: 'outline-secondary'
		},
		text: {
			type: String,
			default: null
		},
		value: {
			type: String,
			required: true,
			default: null
		},
		title: {
			type: String,
			default: i18n.t( 'components.clipboard-button.copy' )
		},
		label: {
			type: String,
			default: i18n.t( 'components.clipboard-button.value' )
		},
		size: {
			type: String,
			default: 'md'
		}
	},
	data(): ComponentData {
		return {
			copyState: null
		};
	},
	methods: {
		handleShown() {
			const { input } = this.$refs;
			if ( input ) {
				( input as HTMLInputElement ).focus();
				( input as HTMLInputElement ).select();
			}
		},
		async handleCopy( _event: Event ) {
			try {
				await navigator.clipboard.writeText( this.value );
				this.copyState = true;
			} catch ( error ) {
				this.copyState = false;
			}
		}
	}
} );
